import { APICallInterface } from 'app/scripts/services/sagas/types';
import { SpotPolicy } from '../../../../../constants';

export const setArticlesConversationPolicyApiCall = ({
  conversationId,
  policy
}: {
  conversationId: string;
  policy: SpotPolicy;
}): APICallInterface => ({
  types: [
    'SET_ARTICLES_CONVERSATION_POLICY_START',
    'SET_ARTICLES_CONVERSATION_POLICY_SUCCESS',
    'SET_ARTICLES_CONVERSATION_POLICY_FAILURE'
  ],
  params: {
    method: 'POST',
    url: '/host-panel/policy/set-conversation-policy',
    payload: {
      conversation_id: conversationId,
      default_policy: policy
    }
  }
});
